(ns ui.view.card.associated-entities.sub
  (:require
   [ui.util :as uu]
   [re-frame.core :as rf]
   [common.entity :as entity]
   [common.util :as cu]
   [ui.state.session.sub :as session-sub]
   [common.schema.registry :as registry]
   [ui.view.card.sub :as common-sub]
   [common.schema.associations :as associations]
   [ui.view.card.associated-entities.model :as model]
   [common.localization :as loc]
   [clojure.set :as set]))

(rf/reg-sub
 ::table-state
 common-sub/card-state-extractor
 (fn [[card-state]
      [_ _ctx table-index]]
   (get-in card-state (model/table-state-path table-index))))

(rf/reg-sub
 ::entity-associations
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/entities ctx])])
 (fn [[card-entities-by-id] [_ ctx]]
   (let [primary-entity-id (:entity-id ctx)]
     (->> card-entities-by-id
          (filter (fn [[_eid entity]]
                    (let [entity-type (:entity/type entity)
                          source (:entity-association/source-entity entity)
                          target (:entity-association/target-entity entity)]
                      (and (= entity-type :entity.type/entity-association)
                           (or (= source primary-entity-id)
                               (= target primary-entity-id))))))
          (mapv second)
          (cu/remove-by :common/disabled? true)))))

(rf/reg-sub
 ::entity-associations-by-other-entity-type
 (fn [[_ ctx]]
   [(rf/subscribe [::entity-associations ctx])
    (rf/subscribe [::common-sub/entities ctx])])
 (fn [[entity-associations
       card-entities-by-id] [_ ctx]]
   (let [primary-entity-id (:entity-id ctx)]
     (->> entity-associations
          (group-by (fn [entity-association]
                      (let [source? (-> entity-association
                                        :entity-association/source-entity
                                        (= primary-entity-id))
                            other-entity-id (if source?
                                              (:entity-association/target-entity entity-association)
                                              (:entity-association/source-entity entity-association))
                            other-entity (get card-entities-by-id other-entity-id)]
                        (:entity/type other-entity))))))))

(rf/reg-sub
 ::table-expanded?
 (fn [[_ ctx table-index]]
   [(rf/subscribe [::table-state ctx table-index])
    (rf/subscribe [::entity-associations-by-other-entity-type ctx])])
 (fn [[table-state
       entity-associations-by-other-entity-type]
      [_ {:keys [card] :as _ctx} table-index]]
   (let [table-entity-type (-> card
                               :card/config
                               :tables
                               (nth table-index)
                               :entity-type)
         associations (get entity-associations-by-other-entity-type table-entity-type)
         user-expanded? (get-in table-state model/table-expanded-path)]
     (if (boolean? user-expanded?)
       user-expanded?
       (< 0 (count associations) 10)))))

(rf/reg-sub
 ::table-group-by-association-type?
 (fn [[_ ctx table-index]]
   [(rf/subscribe [::table-state ctx table-index])])
 (fn [[table-state]
      [_ {:keys [card] :as _ctx} table-index]]
   (let [default-value (-> card
                           :card/config
                           :tables
                           (nth table-index)
                           :group-by-association-type?)
         user-set-value (get-in table-state model/table-group-by-association-type-path)]
     (if (boolean? user-set-value)
       user-set-value
       default-value))))

(rf/reg-sub
 ::table-row-group-expanded-states
 (fn [[_ ctx table-index]]
   [(rf/subscribe [::table-state ctx table-index])])
 (fn [[table-state]]
   (get-in table-state model/table-row-group-expanded-states-path)))

(rf/reg-sub
 ::table-sort-model
 (fn [[_ ctx table-index]]
   [(rf/subscribe [::table-state ctx table-index])])
 (fn [[table-state]
      [_ {:keys [card] :as _ctx} table-index]]
   (let [default-sort-model (get-in card [:card/config :tables table-index :sort-model])
         user-set-sort-model (get table-state :sort-model)]
     (or user-set-sort-model default-sort-model))))

(rf/reg-sub
 ::visible-tables
 (fn [[_ ctx]]
   [(rf/subscribe [::entity-associations-by-other-entity-type ctx])])
 (fn [[entity-associations-by-other-entity-type]
      [_ {:keys [card] :as _ctx}]]
   (->> card
        :card/config
        :tables
        (filterv (fn [table-config]
                   (let [entity-type (:entity-type table-config)
                         associations (get entity-associations-by-other-entity-type entity-type)]
                     (-> associations
                         count
                         pos?)))))))

(rf/reg-sub
 ::table-visible?
 (fn [[_ ctx _table-index]]
   [(rf/subscribe [::entity-associations-by-other-entity-type ctx])])
 (fn [[entity-associations-by-other-entity-type]
      [_ {:keys [card] :as _ctx} table-index]]
   (let [table-entity-type (get-in card [:card/config :tables table-index :entity-type])]
     (->> table-entity-type
          (get entity-associations-by-other-entity-type)
          count
          pos?))))

  ;; FIXME: this does not take into account the fact whether user has acces to dealflow etc different modules
(rf/reg-sub
 ::add-association-options
 (fn [_ [_ card]]
   (->> card
        :card/config
        :tables
        (mapv :entity-type)
        distinct
        (sort-by loc/tr)
        (mapv (fn [entity-type]
                {:value entity-type
                 :label (loc/tr :add- [(-> entity-type
                                           loc/tr
                                           cu/str-trim-lcase)])
                 :icon-class (some->> {:entity/type entity-type}
                                      entity/default-icon
                                      name
                                      (str "fal "))})))))

(rf/reg-sub
 ::entity-associations-for-target-type
 (fn [[_ ctx _target-type]]
   [(rf/subscribe [::entity-associations-by-other-entity-type ctx])])
 (fn [[entity-associations-by-other-entity-type]
      [_ _ctx target-type]]
   (get entity-associations-by-other-entity-type target-type)))

(defn ->row-data
  [{:keys [table-config entity-association association-type-options
           other-entity entities-by-id tenant tenant-schema]}]
  (let [other-entity-id (:db/id other-entity)
        association-id (:db/id entity-association)
        source (:entity-association/source-entity entity-association)
        entity-is-source? (not= source other-entity-id)
        comment-attribute (if entity-is-source?
                            :entity-association/source-comment
                            :entity-association/target-comment)
        comment (if entity-is-source?
                  (:entity-association/source-comment entity-association)
                  (:entity-association/target-comment entity-association))
        association-type (:entity-association/type entity-association)
        association-type-display-value (uu/field-value->materialized-value
                                        {:field :entity-association/type
                                         :value association-type
                                         :tenant tenant
                                         :tenant-schema tenant-schema
                                         :options association-type-options
                                         :id->entity entities-by-id})
        associated-entity-data
        (->> table-config
             :columns
             (mapv :field)
             (remove (fn [field]
                       (or (= field :association-comment)
                           (= field :association-type))))
             (mapv (fn [field]
                     (let [value (get other-entity field)
                           materialized-value (uu/field-value->materialized-value
                                               {:field field
                                                :value value
                                                :tenant tenant
                                                :tenant-schema tenant-schema
                                                :id->entity entities-by-id
                                                :entity other-entity
                                                :show-currency? true})]
                       [field materialized-value])))
             (into {}))]
    (assoc associated-entity-data
           :db/id other-entity-id
           :entity-id other-entity-id
           :comment comment
           :association-comment comment
           :association-id association-id
           :association-type association-type-display-value
           :comment-attribute comment-attribute)))

(rf/reg-sub
 ::table-entity-count
 (fn [[_ ctx _table-index]]
   [(rf/subscribe [::entity-associations-by-other-entity-type ctx])])
 (fn [[associations-by-other-entity-type]
      [_ {:keys [card] :as _ctx} table-index]]
   (let [table-entity-type (-> card
                               :card/config
                               :tables
                               (nth table-index)
                               :entity-type)]
     (->> table-entity-type
          (get associations-by-other-entity-type)
          count))))

(rf/reg-sub
 ::table-columns
 :<- [::session-sub/tenant-schema]
 (fn [tenant-schema [_ {:keys [card] :as _ctx} table-index]]
   (let [table-config (get-in card [:card/config :tables table-index])]
     (->> table-config
          :columns
          (map-indexed
           (fn [index {:keys [field]}]
             (let [field-schema (registry/get-field-schema tenant-schema field)
                   field-label (case field
                                 :association-type (loc/tr :association-type)
                                 :association-comment (loc/tr :comment)
                                 (loc/field-name field field-schema))]
               {:ord index
                :field field
                :label field-label})))))))

(defn row-data-subs
  [[_ {:keys [card] :as ctx} table-index]]
  (let [target-type (get-in card [:card/config :tables table-index :entity-type])]
    [(rf/subscribe [::entity-associations-for-target-type ctx target-type])
     (rf/subscribe [::common-sub/entities ctx])
     (rf/subscribe [::session-sub/entities])
     (rf/subscribe [::session-sub/tenant])
     (rf/subscribe [::session-sub/tenant-schema])]))

(defn row-data-computation
  [[entity-associations
    entities
    global-entities-by-id
    tenant
    tenant-schema]
   [_ {:keys [card entity-id] :as _ctx} table-index]]
  (let [primary-entity-type (:card/entity-type card)
        table-config (get-in card [:card/config :tables table-index])
        target-entity-type (:entity-type table-config)
        entities-by-id (merge entities global-entities-by-id)]
    (->> entity-associations
         (mapv
          (fn [entity-association]
            (let [source-id (:entity-association/source-entity entity-association)
                  target-id (:entity-association/target-entity entity-association)
                  other-entity-id (if (= source-id entity-id) target-id source-id)
                  other-entity (get entities-by-id other-entity-id)
                  association-type-options (some->>
                                            associations/schema
                                            (cu/flip get primary-entity-type)
                                            (cu/flip get target-entity-type)
                                            (keep (fn [[a-t c]]
                                                    {:key   a-t
                                                     :label (loc/tr a-t)})))]
              (->row-data {:table-config table-config
                           :entity-association entity-association
                           :other-entity other-entity
                           :tenant tenant
                           :tenant-schema tenant-schema
                           :entities-by-id entities-by-id
                           :association-type-options association-type-options})))))))

  ;; Copied from frontend.view.field-templates
(def system-fields
  [:common/migration-note
   :common/tenant
   :common/owner-role
   :common/disabled?
   :common/zap-sample?
   :common/gift-sample?
   :common/related-entities
   :common/archived?
   :common/change-meta
   :common/ord
   :common/containing-entity
   :company/clearbit-company
   :company/crunchbase-company
   :company/fullcontact-company
   :company/intelligence-company
   :person/fullcontact-person
   :person/clearbit-person
   :person/intelligence-person
   :oppo/asset-type
   :oppo/asset-class
   :oppo/flagged-by
   :asset/type])

(def hidden-peek-entity-fields
  (set/union
   (set system-fields)
   #{:db/id
     :entity/type
     :common/lower-case-str
     :lower-case-entity}))

(def person-peek-field-priority
  {:person/first-name 1
   :person/last-name 2
   :person/universal-email-address 3})

(defn peek-entity-field-sort
  [entity-type field default-ord]
  (case entity-type
    :entity.type/person (get person-peek-field-priority field default-ord)
    default-ord))

(defn materialized-entity->data-rows
  [entity-type materialized-entity tenant-schema]
  (->> materialized-entity
       (keep (fn [[field materialized-value]]
               (when-not (contains? hidden-peek-entity-fields field)
                 (let [field-schema (registry/get-field-schema tenant-schema field)
                       data-type (:field/data-type field-schema)
                       field-label (loc/field-name field field-schema)
                       default-ord (:field/default-ord field-schema)]
                   {:ord (peek-entity-field-sort entity-type field default-ord)
                    :field field
                    :data-type data-type
                    :field-label field-label
                    :materialized-value materialized-value}))))
       (sort-by :ord)
       (vec)))

(defn entity-peek-data-extractors
  [[_ ctx]]
  [(rf/subscribe [::common-sub/entity-peek-open? ctx])
   (rf/subscribe [::common-sub/entity-peek-entity-id ctx])
   (rf/subscribe [::common-sub/entities ctx])
   (rf/subscribe [::session-sub/entities])
   (rf/subscribe [::session-sub/tenant])
   (rf/subscribe [::session-sub/tenant-schema])])

(defn entity-peek-data-computation
  [[entity-peek-open? peek-entity-id card-entities global-entities tenant tenant-schema]
   [_ {:keys [card]}]]
  (if-not entity-peek-open?
    {:open? false}
    (let [id->entity (merge card-entities global-entities)
          peek-entity (get id->entity peek-entity-id)
          entity-type (:entity/type peek-entity)
          title (entity/display-string peek-entity)

            ;; TODO: This does not work if we allow later multiple tables with same entity types
            ;; Currently not an issue
          peek-config (->> card
                           :card/config
                           :tables
                           (filterv (fn [table-config]
                                      (= entity-type (:entity-type table-config))))
                           first
                           :entity-peek)

          {:keys [visible-fields-strategy visible-fields]} peek-config
            ;; FIXME: all fields does not work correctly, all fields are not visible
            ;; Should be derived from the entity type schema, fix before prod
          peek-entity (cond
                        (= visible-fields-strategy :all-fields)
                        peek-entity

                        (= visible-fields-strategy :fields-that-have-value)
                        (->> peek-entity
                             (filterv (fn [[_field value]]
                                        (not (cu/empty-value? value))))
                             (into {}))

                        (= visible-fields-strategy :selected-fields)
                        (->> visible-fields
                             (mapv (fn [field]
                                     [field (get peek-entity field)]))
                             (into {}))
                        :else
                        (do
                          (js/console.error
                           (str "Unknown entity peek visible fields strategy " visible-fields-strategy))
                          peek-entity))
          materialized-entity (uu/entity->materialized-entity
                               {:entity peek-entity
                                :id->entity id->entity
                                :tenant tenant
                                :tenant-schema tenant-schema})
          data-rows (materialized-entity->data-rows entity-type materialized-entity tenant-schema)]
      {:open? true
       :title title
       :entity-id peek-entity-id
       :entity-type entity-type
       :entity peek-entity
       :data-rows data-rows})))

(rf/reg-sub
 ::entity-peek-data
 entity-peek-data-extractors
 entity-peek-data-computation)

(rf/reg-sub
 ::row-data
 row-data-subs
 row-data-computation)

